import { GetServerSideProps } from 'next';
import { getIntlProps } from '@moxy/next-intl';
import isArray from 'lodash/isArray';
import { BlogPostsPage } from '../../src/containers/blog/BlogPostsPage';
import { fetchBlogPosts } from '../../src/containers/blog/blogPosts';
import { AvailableLanguages, blogAvailableLanguages, isSupportedLanguage } from '../../src/redux/appTypes';
import { BlogPostPageProps } from '../../src/containers/blog/BlogPostPage';

// eslint-disable-next-line import/no-default-export
export default BlogPostsPage;

export const getServerSideProps: GetServerSideProps<BlogPostPageProps> = async (ctx) => {
  ctx.res.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59');
  const languageParam: AvailableLanguages = !isSupportedLanguage(ctx.locale, blogAvailableLanguages)
    ? 'en'
    : ctx.locale;
  const tagParam = ctx.query.tag as string | undefined;

  const limit = 12;
  const pageParam = ctx.query.page ? parseInt(isArray(ctx.query.page) ? ctx.query.page[0] : ctx.query.page, 10) : 0;
  const page = Number.isFinite(pageParam) ? pageParam : 0;
  const blogPosts = await fetchBlogPosts(languageParam, limit, page, tagParam, !!ctx.query.updatedAt);
  return {
    props: {
      blogPosts,
      limit,
      currentPage: page,
      ...(await getIntlProps(ctx.locale))
    }
  };
};
